// Gehrung 45° — Fase über die volle Materialstärke entlang einer Plattenkante,
// in part.meta.miters als [{ edge, angle }]. Engine-frei.
// Kanten wie edges.js/machinings.js (Falz): l1/l2 = Längskanten (bei ∓B),
// b1/b2 = Querkanten (bei ∓L). Die Außenseite (Oberseite, side implizit top)
// behält das volle Maß, die Unterseite weicht um die Stärke zurück.
// v1: Winkel fix 45°, wird aber gespeichert (spätere freie Winkel).
// Exklusivität: Gehrung und Falz schließen sich je Kante aus — withMiter
// entfernt beim Setzen einen Falz auf der Kante; beim Setzen/Umhängen eines
// Falzes muss umgekehrt withoutMiter für dessen Kante angewendet werden.

import { EDGE_KEYS } from "./edges"
import { isFalz } from "./machinings"

const ANGLE = 45

export function mitersOf(part) {
  return part.meta?.miters ?? []
}

// Toggle: vorhandene Gehrung an der Kante entfernen, sonst setzen (max. 1 je
// Kante). Beim Setzen fliegt ein Falz auf derselben Kante raus.
export function withMiter(part, edge) {
  const meta = { ...part.meta }
  const existing = mitersOf(part)
  if (existing.some((miter) => miter.edge === edge)) {
    return packMiters(meta, existing.filter((miter) => miter.edge !== edge))
  }
  if (!EDGE_KEYS.includes(edge)) return meta
  packMiters(meta, [ ...existing, { edge, angle: ANGLE } ])
  const grooves = (meta.grooves ?? []).filter((groove) => !(isFalz(groove) && groove.edge === edge))
  if (grooves.length > 0) meta.grooves = grooves
  else delete meta.grooves
  return meta
}

// Gegenrichtung der Exklusivität: Gehrung einer Kante aus einem Meta entfernen
// (z. B. wenn dort gerade ein Falz gesetzt wird).
export function withoutMiter(meta, edge) {
  const result = { ...meta }
  return packMiters(result, (result.miters ?? []).filter((miter) => miter.edge !== edge))
}

function packMiters(meta, miters) {
  if (miters.length > 0) meta.miters = miters
  else delete meta.miters
  return meta
}
